var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/SeatRequestModal/index.js",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { Modal } from '@wds/modal';
import { Toast } from '@wds/toast';
import { t } from '@sm/intl';
import RequestModalContent from './RequestModalContent';
import PendingModalContent from './PendingModalContent';
import NotAvailableModalContent from './NotAvailableModalContent';
import SeatRequestQuery from './graphql/SeatRequest.graphql';
import COPY from './SeatRequestCopy';
import { CASUAL_USER_ALLOW_EXPORT, STATUS } from './constants';
import { WebAssetsThemeWrapper } from '../../theme';
var SeatRequestModal = function SeatRequestModal(_ref) {
  var _ref2;
  var show = _ref.show,
    onClose = _ref.onClose,
    seatRequestData = _ref.seatRequestData,
    sourceCategoryKey = _ref.sourceCategoryKey,
    sourceFeatureKey = _ref.sourceFeatureKey,
    showToasts = _ref.showToasts;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    toastMessage = _useState2[0],
    setToastMesssage = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    operationStatus = _useState4[0],
    setOperationStatus = _useState4[1];

  // we intentionally separate the prop show, from where
  var _useState5 = useState(show),
    _useState6 = _slicedToArray(_useState5, 2),
    showModal = _useState6[0],
    setShowModal = _useState6[1];
  useEffect(function () {
    setShowModal(show);
  }, [show]);

  // called when user has completed interaction and
  // we either want to show a toast or immediately
  // signal to the parent that we are done.
  var onModalFinished = function onModalFinished(result) {
    setShowModal(false);
    if (showToasts && result !== null && result !== void 0 && result.message && typeof result.message === 'string') {
      setToastMesssage(result.message);
      setOperationStatus(result.status);
    } else if ((result === null || result === void 0 ? void 0 : result.status) === STATUS.SUCCESS || (result === null || result === void 0 ? void 0 : result.status) === STATUS.FAILURE) {
      onClose(result);
    } else {
      onClose({
        status: STATUS.SUCCESS,
        message: null
      });
    }
  };

  // called after toasts have finished displaying
  var onOperationFinished = function onOperationFinished() {
    setToastMesssage(null);
    setShowModal(false);
    onClose({
      status: operationStatus,
      message: toastMessage
    });
  };
  var _useQuery = useQuery(SeatRequestQuery, {
      skip: seatRequestData || !show,
      fetchPolicy: 'network-only',
      onError: function onError() {
        onModalFinished({
          status: STATUS.FAILURE,
          message: t(COPY.TOAST_ERROR)
        });
      }
    }),
    isLoadingSeatRequest = _useQuery.loading,
    data = _useQuery.data;
  var seatRequest = (seatRequestData === null || seatRequestData === void 0 ? void 0 : seatRequestData.seatRequest) || (data === null || data === void 0 ? void 0 : data.user.seatRequest);
  var team = (seatRequestData === null || seatRequestData === void 0 ? void 0 : seatRequestData.team) || (data === null || data === void 0 ? void 0 : data.user.team);
  var isCasualUserAllowExport = ((_ref2 = seatRequestData || (data === null || data === void 0 ? void 0 : data.user)) === null || _ref2 === void 0 ? void 0 : _ref2.featureSetId) === CASUAL_USER_ALLOW_EXPORT;
  if (isLoadingSeatRequest || !seatRequest) {
    return null;
  }
  return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Modal, {
    size: "md",
    show: showModal,
    onClose: onModalFinished,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 7
    }
  }, seatRequest.status === 'AVAILABLE' || seatRequest.status === 'RESPONDED' ? /*#__PURE__*/React.createElement(RequestModalContent, {
    onModalFinished: onModalFinished,
    sourceCategoryKey: sourceCategoryKey,
    sourceFeatureKey: sourceFeatureKey,
    isCasualUserAllowExport: isCasualUserAllowExport,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 11
    }
  }) :
  // eslint-disable-next-line no-nested-ternary
  seatRequest.status === 'PENDING' ? /*#__PURE__*/React.createElement(PendingModalContent, {
    onModalFinished: onModalFinished,
    seatRequest: seatRequest,
    team: team,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 11
    }
  }) : seatRequest.status === 'NOT_AVAILABLE' ? /*#__PURE__*/React.createElement(NotAvailableModalContent, {
    onModalFinished: onModalFinished,
    team: team,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 11
    }
  }) : null), !!toastMessage && /*#__PURE__*/React.createElement(Toast, {
    show: !!toastMessage,
    onClose: onOperationFinished,
    dismissible: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Toast.Title, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 11
    }
  }, toastMessage)));
};
SeatRequestModal.propTypes = {
  /** set to true when you want to show the seat request modal */
  show: PropTypes.bool.isRequired,
  /** Modal will inform you that the operation is completed */
  onClose: PropTypes.func.isRequired,
  /** Optionally pass in the seat request data yourself if you have already queried it.
   *  If this is null, the modal will make it's own request for this data.
   */
  seatRequestData: PropTypes.shape({
    team: PropTypes.shape({
      accountOwner: PropTypes.shape({
        email: PropTypes.string.isRequired,
        firstName: PropTypes.string,
        lastName: PropTypes.string
      }).isRequired
    }).isRequired,
    seatRequest: PropTypes.shape({
      status: PropTypes.string.isRequired
    })
  }),
  /** This is a key that that maps to a category of features that the user is requesting a seat upgrade for
   *  This could be
   */
  sourceCategoryKey: PropTypes.string.isRequired,
  /** This represents the specific feature the user is requesting a seat upgrade for.
   *  It should match a feature key in the pricing service.
   */
  sourceFeatureKey: PropTypes.string,
  /**
   * Show toasts
   */
  showToasts: PropTypes.bool
};
SeatRequestModal.defaultProps = {
  seatRequestData: null,
  sourceFeatureKey: null,
  showToasts: true
};
export default SeatRequestModal;
//# sourceMappingURL=index.js.map